/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS104: Avoid inline assignments
 * DS204: Change includes calls to have a more natural evaluation order
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Promise from 'bluebird';
import _ from 'underscore';

import { Analytics } from '@trello/atlassian-analytics';
import { ApiError } from '@trello/error-handling';
import { featureFlagClient } from '@trello/feature-flag-client';
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';
import { getKey, Key } from '@trello/keybindings';
import { getRecentBoards } from '@trello/recent-boards';
import { getRecentCards } from '@trello/recent-cards';
import { isShortId } from '@trello/shortlinks';
import { parseTrelloUrl } from '@trello/urls';

import { ModelLoader } from 'app/scripts/db/model-loader';
import { ModelCache } from 'app/scripts/db/ModelCache';
import { isOverLimit } from 'app/scripts/lib/limits';
import { Recents } from 'app/scripts/lib/recents';
import { Util } from 'app/scripts/lib/util';
import { Board } from 'app/scripts/models/Board';
import { Card } from 'app/scripts/models/Card';
import Payloads from 'app/scripts/network/payloads';
import { View } from 'app/scripts/views/internal/View';
import { PopoverLimitExceededTemplate } from 'app/scripts/views/templates/PopoverLimitExceededTemplate';
import { PopoverTrelloCompleterTemplate } from 'app/scripts/views/templates/PopoverTrelloCompleterTemplate';
import { SelectBoardTemplate as selectBoardTemplate } from 'app/scripts/views/templates/SelectBoardTemplate';
import { SelectCardTemplate as selectCardTemplate } from 'app/scripts/views/templates/SelectCardTemplate';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';

interface TrelloCompleterView {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _lastQuery: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _lastRenderPromise: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  debounce: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  debouncedSearch: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  items: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  model: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  options: any;
}

class TrelloCompleterView extends View {
  static initClass() {
    this.prototype.viewTitleKey = 'add card or board';

    this.prototype.events = {
      // @ts-expect-error
      'mouseenter .js-select-card,.js-select-board': 'hoverItem',
      'click .js-select-card': 'selectCard',
      'click .js-select-board': 'selectBoard',
      keydown: 'keydownEvent',
      'keyup .js-search': 'keyupEvent',
      'input .js-search': 'updateSearch',
    };
  }

  initialize() {
    this.items = [];
    this.debouncedSearch = this.debounce(this.search, 350).bind(this);
    return this.search('');
  }

  render() {
    const data = {};

    if (!this.model.canAttach()) {
      if (isOverLimit('attachments', 'perCard', this.model.get('limits'))) {
        this.$el.html(PopoverLimitExceededTemplate('perCard'));
      } else if (
        isOverLimit(
          'attachments',
          'perBoard',
          this.model.getBoard().get('limits'),
        )
      ) {
        this.$el.html(PopoverLimitExceededTemplate('perBoard'));
      }
      return this;
    }

    this.$el.html(PopoverTrelloCompleterTemplate(data));

    Promise.resolve(this._lastRenderPromise)
      .then(() => {
        return this.renderItems();
      })
      .done();

    return this;
  }

  renderItems() {
    let data, board;
    $('.js-loading', this.$el).addClass('hide');

    const hiddenCards = new Set([this.model.get('shortLink')]);
    const hiddenBoards = new Set();

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.model.attachmentList.forEach(function (attachment: any) {
      const url = attachment.get('url');
      const { type, shortLink } = parseTrelloUrl(url);
      switch (type) {
        case 'card':
          return hiddenCards.add(shortLink);
        case 'board':
          return hiddenBoards.add(shortLink);
        default:
      }
    });

    const cards = this.items.filter(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (item: any) =>
        // @ts-expect-error TS(2345): Argument of type '"shortLink"' is not assignable t... Remove this comment to see the full error message
        item instanceof Card && !hiddenCards.has(item.get('shortLink')),
    );
    const boards = this.items.filter(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (item: any) =>
        item instanceof Board && !hiddenBoards.has(item.get('shortLink')),
    );

    // eslint-disable-next-line @trello/enforce-variable-case
    const $cardList = $('.js-card-list', this.$el).empty();
    // eslint-disable-next-line @trello/enforce-variable-case
    const $boardList = $('.js-board-list', this.$el).empty();

    if (cards.length > 0) {
      const cardHtml = (() => {
        const result = [];
        for (const card of Array.from(cards)) {
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          data = card.toJSON();
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          board = card.getBoard();

          if (board != null) {
            data.boardName = board.get('name');
          }

          result.push(selectCardTemplate(data));
        }
        return result;
      })();

      $cardList.append(cardHtml);
    }

    if (boards.length > 0) {
      const boardHtml = (() => {
        const result1 = [];
        for (board of Array.from(boards)) {
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          const org = board.getOrganization();
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          data = board.toJSON();

          if (org != null) {
            data.orgName = org.get('displayName');
          }

          result1.push(selectBoardTemplate(data));
        }
        return result1;
      })();

      $boardList.append(boardHtml);
    }

    if (this.items.length > 0) {
      Util.selectMenuItem(this.$el, '.item', this.$el.find('.item').first());
    }

    const hideCardResults = !this._lastQuery && cards.length === 0;
    const hideBoardResults = !this._lastQuery && boards.length === 0;
    $('.js-card-results', this.$el).toggleClass('hide', hideCardResults);
    $('.js-board-results', this.$el).toggleClass('hide', hideBoardResults);
    $('.js-no-card-results', this.$el).toggleClass('hide', cards.length > 0);
    $('.js-no-board-results', this.$el).toggleClass('hide', boards.length > 0);

    return this;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  keyupEvent(e: any) {
    const key = getKey(e);

    if ([Key.ArrowUp, Key.ArrowDown].includes(key)) {
      stopPropagationAndPreventDefault(e);
      Util.navMenuList(this.$el, '.item', key);
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  updateSearch(e: any) {
    const query = $('.js-search', this.$el).val();
    return this.debouncedSearch(query);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  keydownEvent(e: any) {
    let needle;
    if (((needle = getKey(e)), [Key.Enter, Key.Tab].includes(needle))) {
      stopPropagationAndPreventDefault(e);
      // eslint-disable-next-line @trello/enforce-variable-case
      const $item = this.$el
        .find('.item.selected:first')
        .find('.js-select-card,.js-select-board');
      if ($item.length > 0) {
        return $item.click();
      }
    }
  }

  getTextInput() {
    return $(this.options.target);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _renderSettledItems(query: any, eventualItems: any) {
    if (query !== this._lastQuery) {
      return;
    }

    return (this._lastRenderPromise = Promise.resolve(eventualItems)
      .then(function (items) {
        if (_.isArray(items)) {
          return items;
        } else {
          return [items];
        }
      })
      .catch(ApiError, () => [])
      .tap((items) => {
        this.items = items;
        return this.renderItems();
      })
      .finally(() => {
        return (this._lastRenderPromise = null);
      }));
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  search(query: any) {
    if (query === this._lastQuery) {
      return;
    }

    this._lastQuery = query;

    $('.js-card-results', this.$el).addClass('hide');
    $('.js-board-results', this.$el).addClass('hide');
    $('.js-loading', this.$el).removeClass('hide');

    if (query === '') {
      const RECENT_COUNT = 5;

      const isRecentCardsWithDateViewedEnabled = featureFlagClient.get(
        'workflowers.store-recent-cards-view-date',
        false,
      );

      const idRecentCards = _.chain(
        isRecentCardsWithDateViewedEnabled
          ? getRecentCards().map((card) => card.id)
          : Recents.get('card', RECENT_COUNT + 1),
      )
        .without(this.model.id)
        .first(RECENT_COUNT)
        .value();

      const idRecentBoards = _.chain(getRecentBoards().map((board) => board.id))
        .without(this.model.get('idBoard'))
        .first(RECENT_COUNT)
        .value();

      const recentItems = Promise.props({
        recentCards: Promise.map(idRecentCards, (idCard) => {
          return ModelCache.getOrLoad({
            type: 'Card',
            id: idCard,
            payload: Payloads.cardCompleter,
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            loader(id: any) {
              return ModelLoader.loadCardCompleterData(id);
            },
          });
        }),

        recentBoards: Promise.map(idRecentBoards, (idBoard) => {
          return ModelCache.getOrLoad({
            type: 'Board',
            id: idBoard,
            payload: Payloads.boardCompleter,
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            loader(id: any) {
              return ModelLoader.loadBoardCompleterData(id);
            },
          });
        }),
      }).then(({ recentCards, recentBoards }) =>
        _.compact([...Array.from(recentCards), ...Array.from(recentBoards)]),
      );

      this._renderSettledItems(query, recentItems);
      return;
    }

    // See if they're just putting in a URL
    const parsedTrello = parseTrelloUrl(query.trim());
    if (parsedTrello.type === 'card') {
      this._renderSettledItems(
        query,
        // @ts-expect-error TS(2345): Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message
        ModelLoader.loadCardCompleterData(parsedTrello.shortLink),
      );
      return;
    } else if (parsedTrello.type === 'board') {
      this._renderSettledItems(
        query,
        // @ts-expect-error TS(2345): Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message
        ModelLoader.loadBoardCompleterData(parsedTrello.shortLink),
      );
      return;
    }

    // Search for a card short id
    if (isShortId(query)) {
      const { card } = this.options;
      const board = card != null ? card.getBoard() : undefined;
      if (board != null) {
        let referencedCard;
        if ((referencedCard = board.getCard(query)) != null) {
          this._renderSettledItems(query, referencedCard);
        } else {
          this._renderSettledItems(
            query,
            ModelLoader.loadCardData(query, board.id),
          );
        }
        return;
      }
    }

    // Search for a phrase
    const searchOptions = {
      query,
      board_fields: 'name,idOrganization,url',
      modelTypes: 'cards,boards',
      partial: true,
      card_board: true,
    };

    ModelLoader.loadSearchData(searchOptions).nodeify((err, results) => {
      if (err == null) {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        const cards = _.chain(results.cards)
          .map((card) => {
            return ModelCache.get('Card', card.id);
          })
          .sortBy((card) => {
            // @ts-expect-error
            if (card.get('idBoard') === this.model.get('idBoard')) {
              return 0;
            } else {
              return 1;
            }
          })
          .value();

        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        const boards = _.chain(results.boards)
          .map((board) => {
            return ModelCache.get('Board', board.id);
          })
          .sortBy((board) => {
            // Why would you attach a card's board to itself?
            // @ts-expect-error
            if (board.get('id') === this.model.get('idBoard')) {
              return 1;
            } else {
              return 0;
            }
          })
          .value();

        return this._renderSettledItems(query, [
          ...Array.from(cards),
          ...Array.from(boards),
        ]);
      } else {
        this.items = [];
        return this.renderItems();
      }
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  hoverItem(e: any) {
    // eslint-disable-next-line @trello/enforce-variable-case
    const $elem = $(e.target).closest('.item');
    return Util.selectMenuItem(this.$el, '.item', $elem);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  selectCard(e: any) {
    stopPropagationAndPreventDefault(e);
    const idCard = $(e.target, this.$el)
      .closest('.js-select-card')
      .attr('data-id');
    const card = ModelCache.get('Card', idCard);
    if (card != null) {
      this.insertItem(card);
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  selectBoard(e: any) {
    stopPropagationAndPreventDefault(e);
    const idBoard = $(e.target, this.$el)
      .closest('.js-select-board')
      .attr('data-id');
    const board = ModelCache.get('Board', idBoard);
    if (board != null) {
      this.insertItem(board);
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  insertItem(item: any) {
    let word;
    if (this.options.onStartUpload) {
      this.options.onStartUpload(item);
      return;
    }

    const url = item.get('url');
    // eslint-disable-next-line @trello/enforce-variable-case
    const $textInput = this.getTextInput();
    const caretPosition = Util.getCaretPosition($textInput);
    if (caretPosition != null) {
      word = {
        start: caretPosition,
        end: caretPosition,
      };
    }

    Util.insertSelection(
      $textInput,
      `${url} `,
      word != null ? word.start : undefined,
      word != null ? word.end : undefined,
    );
    let actionSubject = 'board';
    const containers = {};

    const isCard = item instanceof Card;

    if (isCard) {
      actionSubject = 'card';
      // @ts-expect-error TS(2339): Property 'card' does not exist on type '{}'.
      containers.card = {
        id: item.id,
      };
    } else {
      // @ts-expect-error TS(2339): Property 'board' does not exist on type '{}'.
      containers.board = {
        id: item.id,
      };
    }

    return Analytics.sendTrackEvent({
      action: 'added',
      // @ts-expect-error TS(2322): Type 'string' is not assignable to type 'ActionSub... Remove this comment to see the full error message
      actionSubject,
      source: 'trelloAddCardInlineDialog',
      containers,
    });
  }
}

TrelloCompleterView.initClass();
export { TrelloCompleterView };
